const UploadImage = ({ ...props }) => {
	return (
		<svg
			{...props}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.9982 8.50129C16.9982 9.3294 16.3268 10.0007 15.4987 10.0007C14.6706 10.0007 13.9993 9.3294 13.9993 8.50129C13.9993 7.67317 14.6706 7.00185 15.4987 7.00185C16.3268 7.00185 16.9982 7.67317 16.9982 8.50129Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 7.99775C2 4.68528 4.68528 2 7.99775 2H16.0023C19.3147 2 22 4.68528 22 7.99775V16.0023C22 19.3147 19.3147 22 16.0022 22H10.0008C9.72474 22 9.50097 21.7762 9.50097 21.5002V20.5006C9.50097 20.2245 9.72474 20.0007 10.0008 20.0007H16.0022C18.2106 20.0007 20.0007 18.2106 20.0007 16.0023V15.5839C18.9507 16.4941 17.6041 16.9998 16.2054 16.9998C14.5139 16.9998 12.9067 16.2606 11.8059 14.9763L8.26603 10.8465C7.80526 10.3089 7.13258 9.99949 6.42457 9.99949C5.08511 9.99949 3.99925 11.0853 3.99925 12.4248V12.4998C3.99925 12.7758 3.77548 12.9996 3.49944 12.9996H2.49981C2.22377 12.9996 2 12.7758 2 12.4998V7.99775ZM16.0023 3.99925C18.2106 3.99925 20.0007 5.78944 20.0007 7.99775V11.2052C20.0007 12.2118 19.6009 13.1772 18.8891 13.8889C18.1774 14.6007 17.212 15.0005 16.2054 15.0005C15.0975 15.0005 14.0449 14.5164 13.3238 13.6752L9.78397 9.54536C8.94338 8.56466 7.71622 8.00024 6.42457 8.00024C5.52909 8.00024 4.69575 8.26626 3.99925 8.72358V7.99775C3.99925 5.78944 5.78944 3.99925 7.99775 3.99925H16.0023Z"
				fill="currentColor"
			/>
			<path
				d="M9.60422 16.6042C9.79949 16.7996 9.7992 17.1164 9.60356 17.3114L8.89731 18.0156C8.70217 18.2101 8.38637 18.21 8.19133 18.0154L7.00191 16.8282V21.4964C7.00191 21.7725 6.77813 21.9962 6.5021 21.9962H5.50247C5.22643 21.9962 5.00266 21.7725 5.00266 21.4964V16.8282L3.81324 18.0154C3.6182 18.21 3.3024 18.2101 3.10725 18.0156L2.40101 17.3114C2.20537 17.1164 2.20508 16.7996 2.40035 16.6042L5.64873 13.3534C5.84395 13.1581 6.16061 13.1581 6.35583 13.3534L9.60422 16.6042Z"
				fill="currentColor"
			/>
		</svg>
	)
}

export default UploadImage
